import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const AllowanceAndDeductionDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Allowance And Deduction Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="col-md-6">
            <h5 className="view-sub-title">Allowance</h5>
            <div className="table-responsive">
              <table className="table table-responsive">
                <thead>
                  <tr>
                    <th>Allowance Name</th>
                    <th>Amount</th>
                    {/* <th>Effective From</th>
                    <th>Effective To</th> */}
                  </tr>
                </thead>
                <tbody>
                  {employee?.allowanceDetails?.map((allownace) => (
                    <tr key={allownace.code}>
                      <td>{allownace.description}</td>
                      <td>{allownace.amount}</td>
                      {/* <td>
                        {format(
                          new Date(allownace.effectiveDateFrom),
                          "yyyy-MM-dd"
                        )}
                      </td>
                      <td>
                        {format(
                          new Date(allownace.effectiveDateTo),
                          "yyyy-MM-dd"
                        )}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-md-6">
            <h5 className="view-sub-title">Deduction</h5>
            <div className="table-responsive">
              <table className="table table-responsive">
                <thead>
                  <tr>
                    <th>Deduction Name</th>
                    <th>Amount</th>
                    {/* <th>Effective From</th>
                    <th>Effective To</th> */}
                  </tr>
                </thead>
                <tbody>
                  {employee?.deductionDetails?.map((deduction) => (
                    <tr key={deduction.code}>
                      <td>{deduction.description}</td>
                      <td>{deduction.amount}</td>
                      {/* <td>
                        {format(
                          new Date(deduction.effectiveDateFrom),
                          "yyyy-MM-dd"
                        )}
                      </td>
                      <td>
                        {format(
                          new Date(deduction.effectiveDateTo),
                          "yyyy-MM-dd"
                        )}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AllowanceAndDeductionDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default AllowanceAndDeductionDetails;
